package com.parmartechnologies.core.feature.address.model

import com.parmartechnologies.core.extension.BaseDataClass
import com.parmartechnologies.core.feature.address.network.PinCode
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class Address @OptIn(ExperimentalTime::class) constructor(
    @SerialName("unique_id") var UniqueId: Long = Clock.System.now().epochSeconds,
    @SerialName("user_id") var UserID: String = "",
    @SerialName("feature_object_id") var FeatureObjectID: String = "",
    @SerialName("name") var Name: String = "",
    @SerialName("zip_code") var ZipCode: Long = 0,
    @SerialName("country") var Country: String = "IN",
    @SerialName("state") var State: String = "",
    @SerialName("city") var City: String = "",
    @SerialName("area") var Area: String = "",
    @SerialName("land_mark") var LandMark: String = "",
    @SerialName("house") var House: String = "",
    @SerialName("flat_number") var FlatNumber: String = "",
    @SerialName("floor") var Floor: String = "",
    @SerialName("mobile_number") var MobileNumber: String = "",
    @SerialName("dial_code") var DialCode: String = "",
    @SerialName("type") var Type: String = "",
    @SerialName("location") var Location: LocationCoordinate = LocationCoordinate(),
    @SerialName("is_primary") var IsPrimary: Int = 0,
    @SerialName("is_deleted") var IsDeleted: Int = 0,
) : BaseDataClass(){
    fun usingPin(pinCode: PinCode): Address {
        State = pinCode.state
        Area = pinCode.district
        City = pinCode.city
        Area = pinCode.area
        try {
            ZipCode = pinCode.pinCode.toLong()
        } catch (e: Exception) {

        }
        try {
            if (!pinCode.latitude.isNullOrEmpty() && !pinCode.longitude.isNullOrEmpty()) {
                Location = LocationCoordinate(
                    latitude = pinCode.longitude.toDouble(),
                    longitude = pinCode.latitude.toDouble(),
                    type = "Point",
                    coordinate = arrayListOf(
                        pinCode.longitude.toDouble(),
                        pinCode.latitude.toDouble()
                    )
                )
            }
        } catch (e: Exception) {

        }


        return this
    }
}